<template>
  <div v-loading="loading">
    <div class="my-charts" ref="myChart"></div>
  </div>
</template>

<script>
import { getWeekChartByKeyWord } from "@/api/charts";
export default {
  data() {
    return {
      loading: false,
      wciData: [],
      tkData: [],
      chartData: [],
      xAxisData: [],
      adScore: [],
      extlinkScore: [],
      liveScore: [],
      mpdocScore: [],
      queryScore: [],
      w1wScore: [],
      finderScore: [],
      searchScore: [],
      topScore: [],
      legendData: [],
      seriesData: [],
    };
  },
  methods: {
    GetAllData(wci_ids, tk_ids) {
      this.loading = true;
      getWeekChartByKeyWord(wci_ids, tk_ids).then((res) => {
        if (res.code == 0) {
          this.wciData = res.data.wcidata;
          this.tkData = res.data.tkdata;

          this.SetData(this.wciData[0].wciKeyId, "wci");
        } else {
          this.$message.error(res.msg);
        }
        this.loading = false;
      });
    },
    SetData(id, dataType) {
      if (dataType == "wci") {
        const fItem = this.wciData.find((item) => item.wciKeyId === id);
        console.log(fItem);
        if (fItem) {
          this.KeyWord = fItem.wciKeyWord;
          this.xAxisData = fItem.wciInfo.map((item) => item.endDate);
          this.adScore = fItem.wciInfo.map((item) => item.adScore);
          this.extlinkScore = fItem.wciInfo.map((item) => item.extLinkScore);
          this.liveScore = fItem.wciInfo.map((item) => item.liveScore);
          this.mpdocScore = fItem.wciInfo.map((item) => item.mpdocScore);
          this.queryScore = fItem.wciInfo.map((item) => item.queryScore);
          this.w1wScore = fItem.wciInfo.map((item) => item.w1wScore);
          this.finderScore = fItem.wciInfo.map((item) => item.finderScore);
          this.legendData = [
            "WCI广告",
            "WCI外链",
            "WCI直播",
            "WCI公众号",
            "WCI搜一搜",
            "WCI问一问",
            "WCI视频号",
          ];
          this.seriesData = [];
          this.seriesData.push({
            name: "WCI广告",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(128, 255, 165)",
                },
                {
                  offset: 1,
                  color: "rgb(1, 191, 236)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: this.adScore,
          });
          this.seriesData.push({
            name: "WCI外链",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(0, 221, 255)",
                },
                {
                  offset: 1,
                  color: "rgb(77, 119, 255)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: this.extlinkScore,
          });
          this.seriesData.push({
            name: "WCI直播",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(55, 162, 255)",
                },
                {
                  offset: 1,
                  color: "rgb(116, 21, 219)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: this.liveScore,
          });
          this.seriesData.push({
            name: "WCI公众号",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(255, 0, 135)",
                },
                {
                  offset: 1,
                  color: "rgb(135, 0, 157)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: this.mpdocScore,
          });
          this.seriesData.push({
            name: "WCI搜一搜",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            label: {
              show: true,
              position: "top",
            },
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(255, 191, 0)",
                },
                {
                  offset: 1,
                  color: "rgb(224, 62, 76)",
                },
              ]),
            },

            emphasis: {
              focus: "series",
            },
            data: this.queryScore,
          });
          this.seriesData.push({
            name: "WCI问一问",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            label: {
              show: true,
              position: "top",
            },
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(100, 191, 0)",
                },
                {
                  offset: 1,
                  color: "rgb(224, 62, 76)",
                },
              ]),
            },

            emphasis: {
              focus: "series",
            },
            data: this.w1wScore,
          });
          this.seriesData.push({
            name: "WCI视频号",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            label: {
              show: true,
              position: "top",
            },
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(255, 191, 0)",
                },
                {
                  offset: 1,
                  color: "rgb(224, 62, 76)",
                },
              ]),
            },

            emphasis: {
              focus: "series",
            },
            data: this.finderScore,
          });
          this.InitOptions();
        }
      } else if (dataType == "tk") {
        const fItem = this.tkData.find((item) => item.tkKeyId === id);
        if (fItem) {
          this.KeyWord = fItem.tkKeyWord;
          this.xAxisData = fItem.tkInfo.map((item) => item.endDate);
          this.searchScore = fItem.tkInfo.map((item) => item.searchScore);
          this.topScore = fItem.tkInfo.map((item) => item.topScore);

          this.legendData = [
            "TK搜索",
            "TK综合"
          ];
          this.seriesData = [];
          this.seriesData.push({
            name: "TK搜索",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(128, 255, 165)",
                },
                {
                  offset: 1,
                  color: "rgb(1, 191, 236)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: this.searchScore,
          });
          this.seriesData.push({
            name: "TK综合",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(0, 221, 255)",
                },
                {
                  offset: 1,
                  color: "rgb(77, 119, 255)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: this.topScore,
          });
          this.InitOptions();
        }
      }
    },
    InitOptions() {
      this.chart = this.$echarts.init(this.$refs.myChart);
      this.chart.clear();
      this.chart.setOption({
        color: [
          "#80FFA5",
          "#00DDFF",
          "#37A2FF",
          "#FF0087",
          "#FFBF00",
          "#00FF00",
        ],
        title: {
          text: this.KeyWord,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
          position: function (pos, params, el, elRect, size) {
            const obj = {
              top: 10,
            };
            obj[["left", "right"][+(pos[0] < size.viewSize[0] / 2)]] = 30;
            return obj;
          },
          formatter: (params) => {
            if (!params || params.length === 0) return "";

            // 使用div包裹所有内容，添加基本样式
            let result = `<div style="padding: 8px;">`;

            // 添加标题，使用粗体和更大的字号
            result += `<div style="font-weight: bold; font-size: 14px; margin-bottom: 8px;">${params[0].name}</div>`;

            // 过滤并处理上图数据
            const topParams = params.filter((item) => item.axisIndex === 0);
            if (topParams.length > 0) {
              // 计算总计值，添加安全检查
              const total = topParams.reduce(
                (sum, item) => sum + (parseFloat(item.value) || 0),
                0
              );
              // 添加每个数据项，使用flex布局对齐
              topParams.forEach((item) => {
                const value = parseFloat(item.value) || 0;
                result += `<div style="display: flex; justify-content: space-between; margin: 2px 0; min-width: 180px;">
        <span style="display: flex; align-items: center;">${item.marker}${
                  item.seriesName
                }</span>
        <span style="font-weight: 500;">${value.toLocaleString()}</span>
      </div>`;
              });

              // 添加分隔线和总计，使用不同的样式突出显示
              result += `<div style="margin: 6px 0; border-top: 1px solid #ddd;"></div>
    <div style="display: flex; justify-content: space-between; font-weight: bold; color: #1890ff;">
      总计
      <span>${total.toLocaleString()}</span>
    </div>`;
            }

            // 过滤并处理下图数据，如果存在则添加分隔线和数据
            const bomParams = params.filter((item) => item.axisIndex === 1);
            if (bomParams.length > 0) {
              // 如果同时有上图数据，添加分隔线
              if (topParams.length > 0) {
                result += `<div style="margin: 8px 0; border-top: 2px solid #f0f0f0;"></div>`;
              }

              // 添加每个数据项
              bomParams.forEach((item) => {
                const value = parseFloat(item.value) || 0;
                result += `<div style="display: flex; justify-content: space-between; margin: 2px 0; min-width: 180px;">
        <span style="display: flex; align-items: center;">${item.marker}${
                  item.seriesName
                }</span>
        <span style="font-weight: 500;">${value.toLocaleString()}</span>
      </div>`;
              });
            }

            // 关闭外层div
            result += `</div>`;
            return result;
          },
        },
        legend: {
          data: this.legendData,
          type: "scroll",
          orient: "vertical",
          left: 10,
          top: 40,
          bottom: 20,
        },
        dataZoom: [
          {
            type: "inside",
          },
          {
            type: "slider",
          },
        ],
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: this.xAxisData,
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: function (value) {
                // 超过1亿用b
                if (value >= 100000000) {
                  return value / 100000000 + " B";
                }
                // 超过1百万用m
                else if (value >= 1000000) {
                  return value / 1000000 + " M";
                }
                // 超过1千用k
                else if (value >= 1000) {
                  return value / 1000 + " K";
                }
                // 小于1千直接返回原值
                return value;
              },
            },
          },
        ],
        series: this.seriesData,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-charts {
  width: 100%; // 设置宽度为100%，使其适应父容器
  height: 30vh; // 设置固定高度，可根据需要调整
}
</style>